<template>
    <div class="Upload">
        <input
            type="file"
            class="Upload-core"
            :accept="customAccept"
            @change="addPic" />
        <div class="Upload-mask">
            <img src="../assets/img/upload.png" alt="">
            <p class="Upload-tip">{{tip || '点击这里上传文件'}}</p>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
	import Language from '../util/language';

	export default {
		props: ['tip', 'uploadType', 'accept', 'maxSize', 'wrongTip'],
        computed: {
	        ...mapState({
		        language: state => state.main.language
	        }),
		    customAccept: function () {
                return this.accept || '*';
		    }
        },
		methods: {
			// 获取描述
			getLabel: function (key) {
				return Language(this.language, key);
			},
			addPic(e) {
				let _this = this;
				// 当前选择的图片
				const file = e.target.files[0];
				// 校验一下文件格式是否合法
                const fileName = file.name;
                let fileTypeOk = true;
                let fileType = '';

                if (fileName.indexOf('.') !== -1) {
                	let fileNameArr = fileName.split('.');
                	if (fileNameArr.length > 1) {
		                fileType = '.' + fileNameArr.pop();
		                fileType = fileType.toLowerCase();
                    } else {
                		fileTypeOk = false;
                    }
                }
                if (this.accept && fileType) {
	                let acceptArr = this.accept.split(',');
	                if (acceptArr.indexOf(fileType) === -1) {
		                fileTypeOk = false;
                    }
                }
                if (!fileTypeOk) {
	                this.$store.commit('main/openMessage', {
		                type: 'warning',
		                message: _this.getLabel('DOCUMENT_NOT_SUPPORT')
	                }, { root: true });
	                return;
                }
				// 判断一下文件是否超限
                if (this.maxSize && (file.size / 1000 / 1000).toFixed(2) > this.maxSize) {
	                this.$store.commit('main/openMessage', {
		                type: 'warning',
		                message: this.$props.wrongTip || _this.getLabel('TIP_OVER_SIZE')
	                }, { root: true });
                	return;
                }
				let formData = new FormData();
				formData.append('type', this.uploadType);
				formData.append('file', file, file.name);
				this.$store.dispatch('main/uploadDocument', {
					formData,
					callBack: (data) => {
						e.target.value = '';
						_this.$emit('change', data);
					}
				});
			}
		}
	}
</script>

<style lang="less" scoped>
    .Upload {
        width: 230px;
        height: 150px;
        position: relative;
        display: inline-block;
        float: left;
        &-core {
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
        }
        &-mask {
            width: 100%;
            height: 100%;
            background: #F2F2F2;
            border-radius: 4px;
            text-align: center;
            padding-top: 35px;
        }
        img {
            width: 44px;
            height: 44px;
            margin-bottom: 20px;
        }
        &-tip {
            text-align: center;
            font-size: 14px;
            color: #666666;
        }
    }
</style>